import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';

import { PrivateRoute, RouteComponent } from 'common/navigation';
import { SuspenseFallback } from 'common/statusIndicators';
import * as NAVIGATION from 'config/navigation';


const Home = React.lazy(() => import('./Home'));
const Login = React.lazy(() => import('./Login'))
const NotAllowed = React.lazy(() => import('./NotAllowed'));
const Demo = React.lazy(() => import('./Demo'));
const ForcedPasswordChange = React.lazy(() => import('./ForcedPasswordChange'));

const Routes = () => (
  <React.Suspense fallback={<SuspenseFallback />}>
    <RouterRoutes>
      <Route
        path={`${NAVIGATION.DEMO}/*`}
        element={<RouteComponent Component={Demo} />}
      />
      <Route
        path={NAVIGATION.LOGIN}
        element={<RouteComponent Component={Login} />}
      />
      <Route
        path={NAVIGATION.NOT_ALLOWED}
        element={<NotAllowed />}
      />
      <Route
        path={NAVIGATION.CHANGE_PASSWORD}
        element={(
          <PrivateRoute passwordChangeRoute>
            <RouteComponent Component={ForcedPasswordChange} />
          </PrivateRoute>
        )}
      />
      <Route
        path={`${NAVIGATION.HOME}*`}
        element={(
          <PrivateRoute>
            <RouteComponent Component={Home} />
          </PrivateRoute>
        )}
      />
    </RouterRoutes>
  </React.Suspense>
);

export default Routes;
